import gql from 'graphql-tag';

export default gql`
  query leadQuery($filter: LeadCollectionFilters) {
    agg: leadCount(field: "vendorName", filter: $filter) {
      key
    }
  }
`;
